module.exports = __webpack_public_path__ + "static/img/4.11386428.png";